import { render, staticRenderFns } from "./RequestNotificationPage.vue?vue&type=template&id=fd7c2a3e&"
import script from "./RequestNotificationPage.vue?vue&type=script&lang=ts&"
export * from "./RequestNotificationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports